module.exports = __webpack_public_path__ + "static/media/30-11.649ffda3.mp3";